'use client';

import { CaretRightIcon } from '@phosphor-icons/react';
import { shortMonthLabel } from '@/lib/transactions/dates';
import { cn } from '@/lib/utils';
import type { ScreenFatura } from './types';

interface Props {
  fatura: ScreenFatura;
  onOpen: (faturaId: string) => void;
  className?: string;
}

/**
 * Tiny pill on credit-card transaction rows, replaces the "Crédito" payment-
 * type label. Carries the bank's color so the user reads "this links to the
 * card's world," not a category dot. Stops propagation so tapping it doesn't
 * also expand the row's collapsible.
 */
export function FaturaAffiliationPill({ fatura, onOpen, className }: Props) {
  const dueDate = fatura.dueDate ? new Date(fatura.dueDate) : null;
  const monthLabel = dueDate ? shortMonthLabel(dueDate) : '—';
  const tinted = `${fatura.bankColor}1F`;
  const handle = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    onOpen(fatura.id);
  };
  return (
    <span
      role="link"
      tabIndex={0}
      onClick={handle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handle(e);
      }}
      className={cn(
        'inline-flex shrink-0 cursor-pointer items-center gap-0.5 rounded-full px-2 py-0.5 text-2xs font-bold tracking-wide uppercase',
        className,
      )}
      style={{ backgroundColor: tinted, color: fatura.bankColor }}
    >
      Fatura {monthLabel}
      <CaretRightIcon className="size-3" weight="bold" />
    </span>
  );
}
